export const Subject = {
  ProductionDeclaration: 'production-declaration',
} as const;
